var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panels",
    {
      attrs: { flat: "", accordion: "" },
      model: {
        value: _vm.open,
        callback: function($$v) {
          _vm.open = $$v
        },
        expression: "open"
      }
    },
    [
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "font-weight-bold" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.generateMessage("properties_360.titles.orders")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c("custom-simple-table", {
                attrs: {
                  item: _vm.current,
                  "i18-path": "properties_360.fields",
                  "table-keys": [
                    "operator_instructions",
                    "reactive_instructions",
                    "dispatcher_instructions"
                  ]
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }